export enum actionTypes {
  SET_COMPANY_DATA = 'SET_COMPANY_DATA',
  SET_COMPANY_DATA_SUCCEEDED = 'SET_COMPANY_DATA_SUCCEEDED',
  SET_COMPANY_DATA_ERROR = 'SET_COMPANY_DATA_ERROR',
  RESET_COMPANY_DATA = 'RESET_COMPANY_DATA',
}

export const InitialState: CompanyState = {
  companyData: null,
  userData: null,
  loading: false,
  isLogged: null,
  error: false,
}

export interface UserData {
  idUsuario: number
  tipoUsuario: string
  nombreUsuario: string
  apellidoUsuario: string
  mailEmpresa: string
  numeroCliente: number
  mensajesTotalNoLeidos: number
  urlResumenCuenta: string
  limitePublicaciones: number
}

export interface CompanyData {
  denominacion: string
  razonSocial: string
  descripcion: string
  logoURL: string
  cuit: string
  pais: {
    id: number
    nombre: string
    isoCode: string
  }
  provincia: {
    id: number
    nombre: string
  }
  ciudad: string
  calle: string
  numero: string
  piso: string
  departamento: string
  codigoPostal: string
  industria: {
    id: number
    nombre: string
  }
  email: string
  webURL: string | null
  cantidadEmpleados: number
  condicionIVA: {
    nombre: string
    claseImpuesto: string
    habilitado: boolean
    tipoNif: string
    codigoTipoNif: string
    id: number
  }
  consultora: boolean
  clienteCRMId: number
  idUsuarioBumeranVendedor: number | null
  idClienteSap: string
  inclusiva: boolean
  id: number
}

export interface CompanyState {
  companyData: CompanyData | null
  userData: UserData | null
  loading: boolean
  isLogged: boolean | null
  error: boolean
}

export interface SetCompanyData {
  type: typeof actionTypes.SET_COMPANY_DATA
  payload: null
}

export interface SetCompanyDataSucceeded {
  type: typeof actionTypes.SET_COMPANY_DATA_SUCCEEDED
  payload: { companyData: CompanyData | null; userData: UserData | null; isLogged: boolean | null }
}

export interface SetCompanyDataError {
  type: typeof actionTypes.SET_COMPANY_DATA_ERROR
  payload: null
}

export interface ResetCompanyData {
  type: typeof actionTypes.RESET_COMPANY_DATA
  payload: null
}

export type CompanyActions = SetCompanyData | SetCompanyDataSucceeded | SetCompanyDataError | ResetCompanyData
